import React from "react";
import { HiOutlineKey } from "react-icons/hi";
import { Button } from "@components";

interface InfoMessageMoleculeProps {
  icon?: React.ReactNode;
  title: string;
  description: string;
  children?: React.ReactNode;
  buttonText?: string;
  onButtonClick?: () => void;
  buttonDisabled?: boolean;
}

export const InfoMessageMolecule: React.FC<InfoMessageMoleculeProps> = ({
  icon = <HiOutlineKey className="h-6 w-6 text-lgb-blue-600 dark:text-white" />,
  title,
  description,
  children,
  buttonText,
  onButtonClick,
  buttonDisabled = false,
}) => {
  return (
    <div className="bg-brand-subtle dark:bg-surface border border-brand-muted dark:border-lgb-blue-400 rounded-lg p-6">
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0">{icon}</div>
        <div className="flex-1">
          <h3 className="text-base font-medium text-lgb-blue-800 dark:text-white mb-2">
            {title}
          </h3>
          <p className="text-sm text-lgb-blue-700 dark:text-white mb-4">
            {description}
          </p>
          {children}
          {buttonText && onButtonClick && (
            <Button
              variant="primary"
              onClick={onButtonClick}
              disabled={buttonDisabled}
            >
              {buttonText}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
